export const parseEditorImage = async (cb) => {
  const response = await new Promise((resolve, reject) =>
    cb((err, res) => {
      if (!err) {
        resolve(res);
      } else {
        reject(err);
      }
    })
  );

  return {
    url: response[0]["EDITOR_KEP_MERET"],
    funkcioid: response[0]["funkcioid"],
  };
};
